export class StatsDepense {
  annee: number;
  typeFamille: string;
  sujetDon: string;
  nombreFamilles: number;

  constructor(data: any) {
    this.annee = data.annee;
    this.typeFamille = data.typeFamille;
    this.sujetDon = data.sujetDon;
    this.nombreFamilles = data.nombreFamilles || 0;
  }
}